module.exports = __webpack_public_path__ + "static/media/StandardBearing.1eab1f82.png";